export default __webpack_public_path__ + "static/media/71.22d3d704.jpeg";